import { InvoicesSettingsPageLayout } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/components/InvoicesSettingsPageLayout";
import { InvoicesSettingsPageProvider } from "../../context/InvoicesSettingsPageProvider";
import { InvoiceSettingsPreview } from "../InvoicesBusinessInformationPage/components/InvoiceSettingsPreview";
import { ClientDefaultsForm } from "./components/ClientDefaultsForm";
import { InvoicesClientDefaultsPageProvider } from "./context/InvoicesClientDefaultsPageProvider";

export const InvoicesClientDefaultsPage = () => (
  <InvoicesSettingsPageProvider>
    <InvoicesClientDefaultsPageProvider>
      <InvoicesSettingsPageLayout tab="client-defaults">
        <div className="grid grid-cols-2 gap-8">
          <ClientDefaultsForm />
          <InvoiceSettingsPreview />
        </div>
      </InvoicesSettingsPageLayout>
    </InvoicesClientDefaultsPageProvider>
  </InvoicesSettingsPageProvider>
);
